// JobsDetails.js
import { useState } from 'react';

const Section = ({ title, children }) => {
  const [open, setOpen] = useState(false);

  return (
    <div className="job-section ">
      <button className="toggle-btn d-flex justify-content-between align-items-center cursor-pointer bg-warning p-1 my-3 rounded shadow-sm" onClick={() => setOpen(!open)}>
        {open ? '🔽' : '▶️'} {title}
      </button>
      {open && <div className="section-content bcgrnd-job-section p-2">{children}</div>}
    </div>
  );
};

const JobsDetails = ({ gaonSrNo }) => {
    const [showModal, setShowModal] = useState(false);
    const [selectedWebinar, setSelectedWebinar] = useState('');
    const [selectedSection, setSelectedSection] = useState('');


  return (
    <div className="jobs-details">
      <Section title="स्पर्धा परीक्षा">
        <h3>स्पर्धा परीक्षांसाठी माहिती व तयारी करा.</h3>
        <div className='m-2 ms-5'> 
            <a href="https://onlinepariksha.co.in/" target="_blank" rel="noopener noreferrer" className="link-btn"><button className="btn btn-danger mt-2 p-2">स्पर्धा परीक्षा पोर्टल 👆🏼</button></a>
            <p>onlinepariksha.co.in</p>
        </div>
        <p>&nbsp; &nbsp; onlinepariksha.co.in ही वेबसाइट विद्यार्थ्यांसाठी सर्व सरकारी स्पर्धापरीक्षांचा online सराव करून, इच्छित ध्येय प्राप्त करण्यासाठी एक उपयुक्त प्लॅटफॉर्म आहे. येथे विविध क्षेत्रांतील सरकारी परीक्षांचे आयोजन केले जाते, ज्यामुळे विद्यार्थ्यांना त्यांच्या अभ्यासाची तयारी अधिक प्रभावीपणे करता येते.</p>
        उदा.<h6 className='spardhapariksha'> SSC, Railways, Banking & Insurance, Teacher Eligibility Test, Defence, UPSC, School Exams, Police Dept. </h6>
        <p>मोबाईल ॲप डाऊनलोड करून फ्री डेमो / नोंदणी करण्यासाठी येथे <a href="https://eclara.in/ticket_bck/apk/app-debug.apk" target="_blank" rel="noopener noreferrer" className="link-btn"><button className="btn btn-danger mt-2 p-2">क्लिक करा 👆🏼</button></a> ॲप इंस्टाल झाल्यानंतर <span className='spardhapariksha'>ONL004</span> हा कोड टाका. </p>
        <p>&nbsp; &nbsp; ही वेबसाइट वापरणे खूप सोपे आहे — युजरने रजिस्ट्रेशन केल्यावर लगेचच परीक्षा द्यायला सुरुवात करू शकतो. परीक्षांचे निकाल, वेळेचे नियोजन, विषयानुसार प्रगती अहवाल, असे अनेक गोष्टींसाठी डॅशबोर्ड उपलब्ध आहे. सरकारी परीक्षेत घवघवीत यश मिळविण्यासाठी आजच संपर्क करा.</p>
        <p>माहिती व संपर्कासाठी : &nbsp;
            <a
                href={`https://wa.me/919923688494`}
                target="_blank"
                rel="noopener noreferrer"
                className="btn btn-success btn-sm"
            >
                व्हॉट्सॲप ओपन
            </a>
        </p>
      </Section>

      <Section title="विविध विषयांवर ऑनलाईन मार्गदर्शन सत्रासाठी नोंदणी">
        <h3>माहितीपूर्ण फ्री वेबिनार साठी नावे नोंदवा</h3>
        <ul>
            {[
            "सरकारी स्पर्धा / बँकिंग परीक्षांबाबत मार्गदर्शन",
            "अकाउंटिंग विषयातील विविध क्षेत्रातील नोकरी संधी मार्गदर्शन",
            "Website Development for businesses",
            "Digital Marketing",
            "१० वी- १२ वी उत्तीर्ण झाल्यानंतरचे Career Guidance",
            ].map((title, index) => (
            <li key={index}>
                <button
                className="btn btn-primary mt-2 p-2"
                onClick={() => {
                    setSelectedWebinar(title);
                    setSelectedSection("विविध विषयांवर ऑनलाईन मार्गदर्शन सत्रासाठी नोंदणी");
                    setShowModal(true);
                }}
                >
                {title}
                </button>
            </li>
            ))}
        </ul>
  <h6>Note:</h6>
  <ol>
  <li> एका विषयाच्या वेबिनार साठी किमान 25 विद्यार्थ्यांची नांवे नोंदणी झाल्यानंतर, नोंदणीकृत विद्यार्थ्यांना वेबिनारची तारीख व वेळ सांगण्यासाठी संपर्क केला जाईल.</li>
  <li> वेबिनार नोंदणीसाठी वय, शिक्षण, व्यवसाय असे कुठलेही बंधन नाही.  </li>
  <li> वरील सर्व विषयांचे वेबिनार पूर्णत: फ्री असतील. </li>
  <li> प्रत्येक वरील विषयातील वेबिनारमध्ये मार्गदर्शन करण्यासाठी, त्या-त्या विषयातले तज्ञ वेळोवेळी Elinje Technosoft, Nashik यांचे मार्फत उपलब्ध केले जातील.</li>

  </ol>
</Section>

<Modal
  show={showModal}
  onClose={() => setShowModal(false)}
  webinarTitle={selectedWebinar}
  sectionTitle={selectedSection} // ✅ This was missing!
/>

      <Section title="Free Online Demo Classes Registration">
      <h3>फ्री डेमो क्लास साठी नावे नोंदवा</h3>
      <ul>
            {[
          "Accounting for businessmen",
          "Tally Certification",
          "11th and 12th commerce classes",
        ].map((title, index) => (
            <li key={index}>
                <button
                className="btn btn-primary mt-2 p-2"
                onClick={() => {
                    setSelectedWebinar(title);
                    setSelectedSection("Free Online Demo Classes Registration");
                    setShowModal(true);
                }}
                >
                {title}
                </button>
            </li>
            ))}
        </ul>
        <h6>Note:</h6>
        <ol>
            <li>किमान 25 विद्यार्थ्यांची नांव नोंदणी झाल्यानंतरच क्लास चालू होईल.</li>
            <li>डेमो क्लास पूर्णत: फ्री आहे.</li>
        </ol>

      </Section>

      <Section title="Skill Development Programs">
      <h3>विविध क्लासेस साठी नावे नोंदवा</h3>
        <ul>
            {[
          "Bag making",
          "Parlour, Basic Makeup",
          "Bridal Mehendi, Sadi Draping",
          "Jewellery Making",
          "Tile Painting, Glass Painting",
          "Chocolate making, Cake making",
        ].map((title, index) => (
            <li key={index}>
                <button
                className="btn btn-primary mt-2 p-2"
                onClick={() => {
                    setSelectedWebinar(title);
                    setSelectedSection("Skill Development Programs");
                    setShowModal(true);
                }}
                >
                {title}
                </button>
            </li>
            ))}
        </ul>
        <h6>Note:</h6>
        <ol>
            <li>किमान 25 विद्यार्थ्यांची नांव नोंदणी झाल्यानंतरच क्लास चालू होईल.</li>
            <li>नांव नोंदणी फ्री आहे.</li>
        </ol>
      </Section>

      <Section title="Spiritual Classes">
      <h3>अध्यात्मिक क्लासेस साठी नावे नोंदवा</h3>
        <ul>
            {[
          "Tarot Cards reading",
          "Crystal & Gems",
          "Rudraksh",
          "Vastu",
          "Meditation",
        ].map((title, index) => (
            <li key={index}>
                <button
                className="btn btn-primary mt-2 p-2"
                onClick={() => {
                    setSelectedWebinar(title);
                    setSelectedSection("Spiritual Classes");
                    setShowModal(true);
                }}
                >
                {title}
                </button>
            </li>
            ))}
        </ul>
        <h6>Note:</h6>
        <ol>
            <li>किमान 25 विद्यार्थ्यांची नांव नोंदणी झाल्यानंतरच क्लास चालू होईल.</li>
            <li>नांव नोंदणी फ्री आहे.</li>
        </ol>
      </Section>

      <Section title="Current Job Openings">
            <a href='https://nregastrep.nic.in/Netnrega/writereaddata/citizen_out/panchregpeople_1806003027_local2526.html'><button className="btn btn-success">नरेगा जॉब-कार्ड यादी</button></a>
        <hr/>
        <h3>रोज नवीन Job Updates लवकरच..</h3>
        <ul>
          <li>🧾 Government Jobs</li>
          <li>🏢 Private Jobs</li>
        </ul>
      </Section>

      <Section title="Local Schools & Colleges">
      <h3>स्थानिक शाळा व महाविद्यालयांची यादी लवकरच..</h3>
      </Section>
    </div>
  );
};

const Modal = ({ show, onClose, webinarTitle, sectionTitle }) => {
    if (!show) return null;
    let modalHeading = '';
    if (sectionTitle === "विविध विषयांवर ऑनलाईन मार्गदर्शन सत्रासाठी नोंदणी") {
      modalHeading = `Webinar on : ${webinarTitle}`;
    } 
    if (sectionTitle === "Free Online Demo Classes Registration") {
      modalHeading = `Demo Class : ${webinarTitle}`;
    }
    if (sectionTitle === "Skill Development Programs") {
        modalHeading = `Skill Program: ${webinarTitle}`;
    }
    if (sectionTitle === "Spiritual Classes") {
        modalHeading = `Spiritual Class : ${webinarTitle}`;
    }
      
    return (
      <div className="modal-backdrop">
        <div className="modal-container-job p-4 bg-white rounded shadow">
          <h5 className="mb-3">{modalHeading}</h5>
          <form onSubmit={async (e) => {
                e.preventDefault();

                const formData = new FormData(e.target);
                formData.append("section", sectionTitle);

                const response = await fetch("https://mazagaon.co.in/api/save_classes_reg.php", {
                method: "POST",
                body: formData,
                });

                const result = await response.text();
                if (result === "success") {
                alert("नोंदणी यशस्वी झाली.");
                onClose();
                } else {
                alert("त्रुटी आली, कृपया पुन्हा प्रयत्न करा.");
                }
            }}
           >

            <div className="form-group mb-2">
              <label>विद्यार्थ्याचे नांव:</label>
              <input type="text" name="St_name" className="form-control" />
            </div>
            <div className="form-group mb-2">
              <label>जन्म दिनांक:&nbsp;</label>
              <input type="Date" name="dob" className="" required />
              &nbsp;&nbsp;&nbsp;
              <label>Gender:&nbsp;</label>
              <select name='gender'>
                <option>स्त्री</option>
                <option>पुरुष</option>
              </select>

            </div>
            <div className="form-group mt-2 mb-2">
              <label>विद्यार्थ्याचा Whatsapp क्र.:</label>
              <input type="text" name="whatsapp" className="form-control"  required />
            </div>
            <div className="form-group mb-2">
              <label>विद्यार्थ्याचा संपूर्ण पत्ता :</label>
              <input type="text" name="address" className="form-control"  required/>
            </div>
            <div className="form-group mb-2">
              <label>पूर्ण झालेले शिक्षण :</label>
              <input type="text" name="education" className="form-control" />
            </div>
            <div className="form-group mb-3">
              <label>विषय :</label>
              <input type="text" name="topic" className="form-control" value={webinarTitle} readOnly />
            </div>
            <div className="d-flex gap-2">
                <button type="submit" className="btn btn-success">नांव नोंदवा</button>
                <button type="button" onClick={onClose} className="btn btn-secondary">Close</button>
            </div>
          </form>
        </div>
      </div>
    );
  };
  

export default JobsDetails;
